module.exports = __webpack_public_path__ + "img/1482338339.8a8370d6.jpg";